import React from 'react'
import './btn.css'
import { useNavigate } from 'react-router-dom'


function HomeBtn() {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/');
    };

  return (
    <div onClick={handleClick} className='btn' id='home-btn'>
      HOME
      </div>
  )
}

export default HomeBtn